import DIApi from './_diApi';

class BudgetItemAPI extends DIApi {
  controllerName = 'BudgetItems';
}

export default new BudgetItemAPI();
